
import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import { Dialog, DialogContent, Grid, Card, CardHeader, Typography, Divider, CardContent, DialogActions, Button, List, ListItem, ListItemText, Chip, Box, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from "@mui/material";

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import { openSnackbar } from "../store/slices/SnackbarSlice";

import { CircularProgressIndicator } from "../components/CircularProgressIndicator";

import { DialogContentStyle, DialogActionsStyle } from "../styles/DialogStyle";

import { CambiarContrasena, ObtenerPerfil } from "../connections/admin/UsuarioConnection";

import { PerfilProps } from "../interfaces/admin/UsuarioInterface";

interface Props {
    openDialog:              boolean;
    handleCloseDialog:       () => void;
}

const defaultUsuario = { correoElectronico: '', curp: '', rfc: '', nombres: '', apellido1: '', apellido2: '', puesto: '', tipoUsuario: '', firmaElectronica: false, contrasena: '', roles: [], diasExpiracionFirmaElectronica: 0, success: false, message: '', }

export const DialogPerfil = ( { openDialog, handleCloseDialog }: Props ) => {

    const dispatch = useDispatch();

    const [usuario, setUsuario] = useState<PerfilProps>( defaultUsuario );
    const [loading, setLoading] = useState( true );
    const [loadingContrasena, setLoadingContrasena] = useState( false );

    const [viewContrasena, setViewContrasena] = useState( false );    
    const [contrasena, setContrasena] = useState( '' );
       
    const handleChangePassword = async () => {       
            
        if( !contrasena ){            
            dispatch( openSnackbar({ message: 'Debe escribir una contraseña', variant: 'warning' }));             
            return;
        } 
        else{

            setLoadingContrasena( true );

            await CambiarContrasena({ contrasena }).then( resp => {
                
                const { success, message } = resp;

                if( success ){       
                        
                    setTimeout(() => {
          
                        dispatch( openSnackbar({ message: 'Se cambió la contraseña correctamente', variant: 'success' }));                             
                        setLoadingContrasena( false );

                    }, 400);
                    
                }
                else{

                    setTimeout(() => {    
       
                        dispatch( openSnackbar({ message: message, variant: 'error' }));            
                        setLoadingContrasena( false );

                    }, 400);
                    
                }
            });   

        }

    }

    useEffect(() => {
      
        async function obtener() {

            setLoading( true );
            
            await ObtenerPerfil().then( resp => {

                setTimeout(() => {

                    setUsuario( resp );
                    setContrasena( resp.contrasena );
                    setLoading( false );
                    
                }, 700);

            });

        }
    
        if( openDialog ){
            obtener();        
        }

    }, [ openDialog ])    

    return (
        <>
            
            <Dialog open={ openDialog } fullWidth={true} maxWidth='md'>       
                
                <DialogContent sx={ DialogContentStyle }>    

                    {
                        loading
                        ?
                            <Box sx={{ textAlign: 'center', alignItems: 'center', minHeight: 450 }}>
                                <CircularProgressIndicator mt={25} />
                            </Box>
                        :
                            <Grid container spacing={3}>                      

                                <Grid size={{ xs: 12, md: 6 }}>

                                    <Card>
                                        <CardHeader sx={{ backgroundColor: (theme) => theme.palette.primary.main }} subheader={ <Typography sx={{ fontWeight: '400', color: 'white' }}> Información del usuario </Typography> }/>
                                        
                                        <Divider />
                                    
                                        <CardContent>

                                            <List disablePadding>

                                                <ListItem sx={{ px: 0 }}>

                                                    <ListItemText
                                                        sx={{ mr: 2 }}
                                                        primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Curp: </Typography> }
                                                        secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { usuario.curp } </Typography> }
                                                    />

                                                </ListItem>

                                                <ListItem sx={{ px: 0 }}>

                                                    <ListItemText
                                                        sx={{ mr: 2 }}
                                                        primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Nombre: </Typography> }
                                                        secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { usuario.nombres } </Typography> }
                                                    />

                                                </ListItem>
                                                
                                                <ListItem sx={{ px: 0 }}>

                                                    <ListItemText
                                                        sx={{ mr: 2 }}
                                                        primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Apellidos: </Typography> }
                                                        secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { usuario.apellido1 } { usuario.apellido2 } </Typography> }
                                                    />

                                                </ListItem>

                                                {
                                                    usuario.puesto
                                                    &&
                                                        <ListItem sx={{ px: 0 }}>

                                                            <ListItemText
                                                                sx={{ mr: 2 }}
                                                                primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Puesto: </Typography> }
                                                                secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { usuario.puesto.toLocaleUpperCase() } </Typography> }
                                                            />

                                                        </ListItem>
                                                }                                                

                                            </List>
                                        
                                        </CardContent>

                                    </Card>

                                </Grid>    

                                <Grid size={{ xs: 12, md: 6 }}>

                                    <Card>
                                        <CardHeader sx={{ backgroundColor: (theme) => theme.palette.primary.main }} subheader={ <Typography sx={{ fontWeight: '400', color: 'white' }}> Información de la cuenta </Typography> }/>
                                        
                                        <Divider />
                                    
                                        <CardContent>

                                            <List disablePadding>                        
                                                
                                                <ListItem sx={{ px: 0 }}>

                                                    <ListItemText
                                                        sx={{ mr: 2 }}
                                                        primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Correo electrónico: </Typography> }
                                                        secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { usuario.correoElectronico } </Typography> }
                                                    />

                                                </ListItem>

                                            </List>

                                            <FormControl variant="outlined" fullWidth sx={{ mt: 2 }}>
                                                <InputLabel shrink>Contraseña</InputLabel>
                                                <OutlinedInput
                                                    notched
                                                    label="Contraseña"
                                                    name="contrasena"
                                                    placeholder='Escribe la nueva contraseña'
                                                    type={ viewContrasena ? 'text' : 'password'}
                                                    value={ contrasena }                                
                                                    onChange={ (e) => setContrasena( e.target.value ) }
                                                    endAdornment={
                                                        <InputAdornment position="end">
                                                            <IconButton onClick={ () => setViewContrasena( (prev) => !prev ) } edge="end" >
                                                                {
                                                                    viewContrasena
                                                                    ?
                                                                        <VisibilityOffIcon />
                                                                    :
                                                                        <VisibilityIcon />
                                                                }                                                    
                                                            </IconButton>
                                                        </InputAdornment>
                                                    }
                                                />
                                            </FormControl>    

                                            <Box sx={{ my: 2, textAlign: 'end' }}>

                                                <Button
                                                    fullWidth
                                                    variant="contained"
                                                    color="primary"
                                                    disabled={ contrasena === '' }
                                                    onClick={ handleChangePassword }
                                                    loading={ loadingContrasena }
                                                >
                                                    Cambiar contraseña
                                                </Button>

                                            </Box>     

                                        </CardContent>

                                    </Card>

                                </Grid>      

                                <Grid size={{ xs: 12, md: 12 }}>  

                                    <Card>
                                        <CardHeader sx={{ backgroundColor: (theme) => theme.palette.primary.main }} subheader={ <Typography sx={{ fontWeight: '400', color: 'white' }}> Permisos </Typography> }/>
                                        
                                        <Divider />
                                    
                                        <CardContent>
                                        
                                            <Grid container spacing={3} textAlign={'center'}>

                                                {
                                                    usuario.roles?.map ( ( { descripcion }, index ) => (

                                                        <Grid key={ index } size={{ md: 4, xs: 12 }}>

                                                            <Chip 
                                                                variant="outlined" 
                                                                color="secondary"
                                                                sx={{ py: 2, px: 1 }}
                                                                label={ descripcion.substring(0, 35) + ( descripcion.substring(35).length > 0 ? '....' : '' ) }
                                                            />

                                                        </Grid>

                                                    ))
                                                }

                                                {
                                                    usuario.roles?.length === 0
                                                    &&
                                                        <Grid size={{ md: 12, xs: 12 }} sx={{ textAlign: 'center' }}>
                                                            <Typography variant="subtitle2" color="secondary" fontSize={14}>No tiene permisos asignados</Typography>
                                                        </Grid>
                                                }

                                            </Grid>
                                            
                                        </CardContent>

                                    </Card>

                                </Grid>              
                                
                            </Grid>     
                    }  

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    <Button 
                        color="secondary"
                        onClick={ () => { handleCloseDialog(); setViewContrasena( false); } }
                    > 
                        Cancelar 
                    </Button>

                </DialogActions>

            </Dialog>

        </>
    )
}
